import axios from 'axios'

const service = axios.create({
  baseURL: 'https://api.mokyun.com/'
})

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js